import { List,Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const SyncEntityFolderSettingsRecord = Record({
  folderId: null,
  mainType: null,
  flattened: true, // should everything in the folder be flattened to one level?
  defaultDocumentType: null,
  defaultFolderType: null,
  levels: List()
});

const data = {
  collections: {
    levels: "SyncFolderLevelSettingsRecord"
  }
};

createFromJS.registerCallback(
  "SyncEntityFolderSettingsRecord",
  createFromJS.createNestedCallback(SyncEntityFolderSettingsRecord, data)
);
